import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FaFilter, FaRedoAlt } from "react-icons/fa";

interface Props {
  search: string;
  selectedWilaya: string;
  selectedSector: string;
  selectedPyramid: string;
  selectedExport: string;
  selectedHomologation: string;
  wilayas: string[];
  sectors: string[];
  pyramids: string[];
  homologations: string[];
  onSearch: (value: string) => void;
  onWilaya: (value: string) => void;
  onSector: (value: string) => void;
  onPyramid: (value: string) => void;
  onExport: (value: string) => void;
  onHomologation: (value: string) => void;
  onReset: () => void;
}

const CartographyFilters: React.FC<Props> = ({
  search,
  selectedWilaya,
  selectedSector,
  selectedPyramid,
  selectedExport,
  selectedHomologation,
  wilayas,
  sectors,
  pyramids,
  homologations,
  onSearch,
  onWilaya,
  onSector,
  onPyramid,
  onExport,
  onHomologation,
  onReset,
}) => {
  return (
    <Card className="aida-filter-card">
      <Card.Body>
        <div className="aida-section-heading mb-3">
          <div>
            <h5><FaFilter /> Filtres cartographiques</h5>
            <p>Affiner la lecture nationale par localisation, filière, maturité, export et homologation.</p>
          </div>
          <Button variant="outline-secondary" size="sm" onClick={onReset}>
            <FaRedoAlt className="me-1" /> Réinitialiser
          </Button>
        </div>

        <Row className="g-3">
          <Col xl={3} lg={4} md={6}>
            <Form.Label>Recherche fournisseur</Form.Label>
            <Form.Control value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Nom, raison sociale..." />
          </Col>

          <Col xl={2} lg={4} md={6}>
            <Form.Label>Wilaya</Form.Label>
            <Form.Select value={selectedWilaya} onChange={(e) => onWilaya(e.target.value)}>
              <option value="">Toutes</option>
              {wilayas.map((item) => <option key={item} value={item}>{item}</option>)}
            </Form.Select>
          </Col>

          <Col xl={2} lg={4} md={6}>
            <Form.Label>Filière</Form.Label>
            <Form.Select value={selectedSector} onChange={(e) => onSector(e.target.value)}>
              <option value="">Toutes</option>
              {sectors.map((item) => <option key={item} value={item}>{item}</option>)}
            </Form.Select>
          </Col>

          <Col xl={2} lg={4} md={6}>
            <Form.Label>Niveau pyramidal</Form.Label>
            <Form.Select value={selectedPyramid} onChange={(e) => onPyramid(e.target.value)}>
              <option value="">Tous</option>
              {pyramids.map((item) => <option key={item} value={item}>{item}</option>)}
            </Form.Select>
          </Col>

          <Col xl={1} lg={4} md={6}>
            <Form.Label>Export</Form.Label>
            <Form.Select value={selectedExport} onChange={(e) => onExport(e.target.value)}>
              <option value="">Tous</option>
              <option value="Export-ready">Export-ready</option>
              <option value="Potentiel">Potentiel</option>
              <option value="Non">Non</option>
            </Form.Select>
          </Col>

          <Col xl={2} lg={4} md={6}>
            <Form.Label>Homologation</Form.Label>
            <Form.Select value={selectedHomologation} onChange={(e) => onHomologation(e.target.value)}>
              <option value="">Toutes</option>
              {homologations.map((item) => <option key={item} value={item}>{item}</option>)}
            </Form.Select>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CartographyFilters;
